/* tslint:disable */
/* eslint-disable */
export enum PlanType {
  Slab = 'SLAB',
  Wall = 'WALL'
}
